module.exports = __webpack_public_path__ + "img/goodsB3.115cd17c.png";